export default __webpack_public_path__ + "static/media/Contemplative Helm.3d2a52c8.jpg";